const DevRating = (props) => {
    return (
        props.icon
    )
};

export default DevRating;